export function getApiErrorMessage(error: any, fallback = "Request failed") {
  const status = error?.response?.status;
  const data = error?.response?.data;

  const message =
    data?.error ||
    data?.message ||
    error?.message ||
    fallback;

  return status ? `${status}: ${message}` : message;
}

